import { put, takeEvery, delay } from 'redux-saga/effects'
import { types, IRouterPushAction } from '../types/router'
import * as actions from '../actions/router'

export function* redirectSaga(action: IRouterPushAction) {
  yield delay(0)
  yield put(actions.cleanRouter())
}

export function* routerWatcher() {
  yield takeEvery(types.ROUTER_PUSH, redirectSaga)
}
